import i18n from "@/configs/lang"
import { api } from "./api"

export const utils = {
  parseJwt: function (token) {
    var base64Url = token.split(".")[1]
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/")
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
        })
        .join("")
    )
    return JSON.parse(jsonPayload)
  },
  buildPagingTable: function (arr, page, pageSize) {
    var newTableList = []
    var i = page
    var originTableList = arr
    var pageSize = pageSize

    newTableList = originTableList.slice((i - 1) * pageSize, i * pageSize)
    return newTableList
  },
  alertMessage: function (vm, code, message, title, cb) {
    //var title = code == 0 ? 'Success' : 'FAIL';
    var alertMessage = message
    var alertTitle = title

    if (code == 0) {
      alertMessage = vm.$t("message.alert." + message)
      alertTitle = vm.$t("message.title." + title)
    } else {
      alertTitle = vm.$t("message.title.error")
    }

    vm.$alert(alertMessage, alertTitle, {
      confirmButtonText: vm.$t("pages.button.confirm"),
      dangerouslyUseHTMLString: true,
      callback: (action) => {
        if (action == "confirm") {
          if (cb != undefined && cb != null) {
            cb()
          }
        }
      },
    })
  },
  pad: function (num) {
    var norm = Math.floor(Math.abs(num))
    return (norm < 10 ? "0" : "") + norm
  },
  getDateTime: function (date) {
    //input Date()
    var datetime = date //new Date(date);
    var yy = datetime.getFullYear()
    var mm = (datetime.getMonth() + 1 < 10 ? "0" : "") + (datetime.getMonth() + 1)
    var dd = (datetime.getDate() < 10 ? "0" : "") + datetime.getDate()
    var hh = (datetime.getHours() < 10 ? "0" : "") + datetime.getHours()
    var MM = (datetime.getMinutes() < 10 ? "0" : "") + datetime.getMinutes()
    var newDate = [yy + "-" + mm + "-" + dd, hh + ":" + MM]

    return newDate
  },
  getISOString: function (val) {
    //input 2020-10-1 23:30:00
    var newDate
    if (val == "now") {
      var date = new Date()
    } else {
      val = val.replace(new RegExp(/-/gm), "/")
      var date = new Date(val)
    }

    newDate =
      date.getFullYear() +
      "-" +
      utils.pad(date.getMonth() + 1) +
      "-" +
      utils.pad(date.getDate()) +
      "T" +
      utils.pad(date.getHours()) +
      ":" +
      utils.pad(date.getMinutes()) +
      ":" +
      utils.pad(date.getSeconds()) +
      "." +
      (date.getMilliseconds() / 1000).toFixed(3).slice(2, 5) +
      "Z"

    return newDate
  },
  parseISOStringToDate: function (s) {
    var b = s.split(/\D+/)
    return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]))
  },
  getMonthFirstLastDate: function () {
    //return new date()
    var date = new Date()
    var y = date.getFullYear()
    var m = date.getMonth()

    var firstDate = new Date(y, m, 1, 0, 0)
    var lastDate = new Date(y, m + 1, 0, 23, 59)
    lastDate = lastDate.setDate(lastDate.getDate())
    lastDate = new Date(lastDate)

    return [firstDate, lastDate]
  },
  dateRange: function (startDate, rangeDays) {
    //input startDate:Date(), rangeDays:-30; output: [startDate(isoString),endDate(isoString)]
    var firstDate = new Date(startDate.getTime())
    var secDate = new Date(startDate.getTime())
    firstDate.setDate(secDate.getDate() + rangeDays)

    var firstDateArray = utils.getDateTime(firstDate)
    var secDateArray = utils.getDateTime(secDate)

    var firstDatetime = utils.getISOString(firstDateArray[0] + " " + firstDateArray[1])
    var secDatetime = utils.getISOString(secDateArray[0] + " " + secDateArray[1])

    var startDate = firstDate > secDate ? secDateArray[0] : firstDateArray[0]
    var endDate = firstDate > secDate ? firstDateArray[0] : secDateArray[0]

    var startDatetime = firstDate > secDate ? secDatetime : firstDatetime
    var endDatetime = firstDate > secDate ? firstDatetime : secDatetime

    var returnDate = {
      datetime: [startDatetime, endDatetime],
      date: [startDate, endDate],
    }
    return returnDate
  },
  exportExcel: function (json, name) {
    /* convert state to workbook */
    var data = new Array()
    var keyArray = new Array()

    for (const key1 in json) {
      if (json.hasOwnProperty(key1)) {
        const element = json[key1]
        var rowDataArray = new Array()
        for (const key2 in element) {
          if (element.hasOwnProperty(key2)) {
            const element2 = element[key2]
            rowDataArray.push(element2)
            if (keyArray.length < utils.getLength(element)) {
              keyArray.push(key2)
            }
          }
        }
        data.push(rowDataArray)
      }
    }
    data.splice(0, 0, keyArray)
    const ws = XLSX.utils.aoa_to_sheet(data)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, "SheetJS")
    /* generate file and send to client */
    XLSX.writeFile(wb, name + ".xlsx")
    /*https://juejin.im/post/6844903944397783054*/
  },
    exportExcelWithHeader: function (header, data, sheetName, name) {
    import("xlsx").then((XLSX) => {
      //Had to create a new workbook and then add the header
      const wb = XLSX.utils.book_new()
      for (var i = 0; i < header.length; i++) {
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, header[i])
        //Starting in the second row to avoid overriding and skipping headers
        XLSX.utils.sheet_add_json(ws, data[i], { origin: "A2", skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws, sheetName[i])
      }
      XLSX.writeFile(wb, name + ".xlsx")
    })
  },
  getLength: function (obj) {
    var count = 0
    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        count++
      }
    }

    return count
  },
  newDateFormat: function (val) {
    var ts
    if (val.indexOf("T") >= 0) {
      //input isoString
      ts = val.split(/\D+/)
      var date = new Date(ts[0] + "/" + ts[1] + "/" + ts[2] + " " + ts[3] + ":" + ts[4] + ":" + ts[5])
    } else {
      //input 2020-10-11 12:00:00
      ts = val.replace(new RegExp(/-/gm), "/")
      var date = new Date(ts)
    }
    return date
  },
  sleep: function (milliseconds) {
    var start = new Date().getTime()
    for (var i = 0; i < 1e7; i++) {
      if (new Date().getTime() - start > milliseconds) {
        break
      }
    }
  },
  exportExcel: function (json, name) {
    /* convert state to workbook */
    var data = new Array()
    var keyArray = new Array()

    for (const key1 in json) {
      if (json.hasOwnProperty(key1)) {
        const element = json[key1]
        var rowDataArray = new Array()
        for (const key2 in element) {
          if (element.hasOwnProperty(key2)) {
            const element2 = element[key2]
            rowDataArray.push(element2)
            if (keyArray.length < utils.getLength(element)) {
              keyArray.push(key2)
            }
          }
        }
        data.push(rowDataArray)
      }
    }
    data.splice(0, 0, keyArray)
    import("xlsx").then((XLSX) => {
      const ws = XLSX.utils.aoa_to_sheet(data)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, "SheetJS")
      /* generate file and send to client */
      XLSX.writeFile(wb, name + ".xlsx")
    })
    /*https://juejin.im/post/6844903944397783054*/
  },
  getCodeListWithCulture: async function (region, area, codeType) {
    if (region && area && codeType) {
      let res = await api.apiGetCodeListWithCulture({ region: region, area: area, codeType: codeType })
      return res.data
    } else {
      return []
    }
  },
  getFormateDateTime: function (type, dtstring) {
    if (dtstring) {
      if (type == "Date") return dtstring.slice(0, 10)
      if (type == "Time") return dtstring.slice(11, 16)
      if (type == "DateTime") return dtstring.slice(0, 10) + " " + dtstring.slice(11, 16)
    }
    return ""
  },  
  toLocalDateTime: function (dtstring) {
    if (dtstring == null) return ""
    var dt = new Date(dtstring + "+0800") //DB資料為台灣時間 因此先用台灣時區轉回標準時間
    var hrs = -(new Date().getTimezoneOffset() / 60)
    dt.setHours(dt.getHours() + hrs)
    return (
      dt.getFullYear() +
      "/" +
      (dt.getMonth() + 1) +
      "/" +
      dt.getDate() +
      " " +
      this.paddingLeft(dt.getHours().toString(), 2) +
      ":" +
      this.paddingLeft(dt.getMinutes().toString(), 2) +
      ":" +
      this.paddingLeft(dt.getSeconds().toString(), 2)
    )
  },
  paddingLeft: function (str, lenght) {
    if (str.length >= lenght) {
      return str
    } else {
      return this.paddingLeft("0" + str, lenght)
    }
  },
  showLoading: function (vm) {
    vm.$store.state.Loading = vm.$loading({ fullscreen: true, text: vm.$t("pages.wording.requestProcessing") })
  },
  closeLoading: function (vm) {
    vm.$store.state.Loading.close()
  },   
  ValidateDeltaDomain: (url) => {
    if (process.env.NODE_ENV.trim() === "development") return true
    const validDomain = process.env.VUE_APP_DOMAIN
    const host = new URL(url).hostname // 取出 hostname
    return host === validDomain || host.endsWith("." + validDomain)
  },
  formatDigitalNumber(num) {
    const n = Number(num)
    const fixed = n.toFixed(4)
    return fixed.replace(/\.?0+$/, "");
  }
}
const Translate = (paramName) => {
  let locale = i18n.locale
  let params = paramName.split(".")
  let message = i18n.messages[locale]
  for (let p in params) {
    message = message[params[p]]
  }
  return message
}

const IsFullTypeChar = (inputValue) => {
  return inputValue.match(/[\uff00-\uffff]/g)
}
export { Translate, IsFullTypeChar }
